import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

const { CustomerAddress } = Mobi2Go._class;
const { classNames } = Mobi2Go.helpers;

const AddressForm = ({
    address,
    is_showing,
    onTypeChange,
    onSpecificNumberChange,
    onNameChange,
    onStreetNumberChange,
    onStreetNameChange,
    onCommentChange,
    onSuburbChange,
    onPostcodeChange
}) => {
    const [t] = useTranslation('locations.finder');

    return (
        <div
            className={classNames(
                'm2g-customer-address',
                'm2g-customer-address--v2',
                {
                    'm2g-customer-address--hidden': !is_showing,
                }
            )}
        >
            <div className="m2g-customer-address-animation-container">
                <div
                    data-type-group
                    className="m2g-customer-address-type m2g-customer-address-form-group"
                >
                    <div
                        data-type-label
                        className="m2g-customer-address-form-group-label"
                    >
                        {address.getPropertyLabel('type')}
                    </div>
                    <div
                        className="m2g-input-container m2g-customer-address-form-group-controls m2g-form-element-group"
                        data-icon-after="select"
                    >
                        <select
                            data-type
                            data-field="type"
                            value={address ? address.type : ''}
                            onChange={e => onTypeChange(e.target.value)}
                            className="m2g-customer-address-type-select m2g-select m2g-form-element--full-width"
                        >
                            <option value="residential">
                                {t('residential_address')}
                            </option>
                            <option value="business">
                                {t('business_address')}
                            </option>
                            <option value="apartment">
                                {t('apartment_address')}
                            </option>
                            <option value="hotel">{t('hotel_address')}</option>
                        </select>
                    </div>
                </div>

                <div
                    data-name-group
                    className={classNames(
                        'm2g-customer-address-line-1',
                        'm2g-customer-address-form-group',
                        {
                            'm2g-hidden':
                                !address || address.type === 'residential',
                        }
                    )}
                >
                    <div
                        data-name-label
                        className="m2g-customer-address-form-group-label"
                    >
                        {address.getPropertyLabel('name')}
                    </div>
                    <div className="m2g-customer-address-form-group-controls m2g-form-element-group">
                        <input
                            data-name
                            data-field="name"
                            className="m2g-customer-address-name-input m2g-input m2g-form-element--three-quarter-width m2g-form-element--right-join"
                            value={address ? address.name || '' : ''}
                            onChange={e => onNameChange(e.target.value)}
                            placeholder={address.getPropertyPlaceholder('name')}
                        />
                        <input
                            data-specific-number
                            data-field="specific_number"
                            className="m2g-customer-address-specific-number-input m2g-input m2g-form-element--one-quarter-width m2g-form-element--left-join"
                            value={
                                !address ? '' : address.specific_number || ''
                            }
                            onChange={e =>
                                onSpecificNumberChange(e.target.value)
                            }
                            placeholder={address.getPropertyPlaceholder(
                                'specific_number'
                            )}
                        />
                    </div>
                </div>

                <div
                    data-street-group
                    className="m2g-customer-address-line-2 m2g-customer-address-form-group"
                >
                    <div
                        data-street-label
                        className="m2g-customer-address-form-group-label"
                    >
                        {address.getPropertyLabel('street_name')}
                    </div>

                    {address && address.type === 'residential' ? (
                        <div className="m2g-customer-address-form-group-controls m2g-form-element-group">
                            <input
                                data-specific-number
                                data-field="specific_number"
                                readOnly={
                                    !address.isPropertyEditable(
                                        'specific_number'
                                    )
                                }
                                className="m2g-customer-address-specific-number-input m2g-input m2g-form-element--one-quarter-width m2g-form-element--right-join"
                                value={
                                    !address
                                        ? ''
                                        : address.specific_number || ''
                                }
                                onChange={e =>
                                    onSpecificNumberChange(e.target.value)
                                }
                                placeholder={address.getPropertyPlaceholder(
                                    'specific_number'
                                )}
                            />

                            <input
                                data-street-number
                                data-field="street_number"
                                readOnly={
                                    !address.isPropertyEditable('street_number')
                                }
                                onChange={e =>
                                    onStreetNumberChange(e.target.value)
                                }
                                className="m2g-customer-address-street-number-input m2g-input m2g-form-element--one-quarter-width m2g-form-element--center-join"
                                value={
                                    !address ? '' : address.street_number || ''
                                }
                                placeholder={address.getPropertyPlaceholder(
                                    'street_number'
                                )}
                            />

                            <input
                                data-street-name
                                data-field="street_name"
                                readOnly={
                                    !address.isPropertyEditable('street_name')
                                }
                                onChange={e =>
                                    onStreetNameChange(e.target.value)
                                }
                                className="m2g-customer-address-street-name-input m2g-input m2g-form-element--half-width m2g-form-element--left-join"
                                value={
                                    !address ? '' : address.street_name || ''
                                }
                                placeholder={address.getPropertyPlaceholder(
                                    'street_name'
                                )}
                            />
                        </div>
                    ) : (
                        <div className="m2g-customer-address-form-group-controls m2g-form-element-group">
                            <input
                                data-street-number
                                data-field="street_number"
                                readOnly={
                                    !address.isPropertyEditable('street_number')
                                }
                                onChange={e =>
                                    onStreetNumberChange(e.target.value)
                                }
                                className="m2g-customer-address-street-number-input m2g-input m2g-form-element--one-quarter-width m2g-form-element--right-join"
                                value={
                                    !address ? '' : address.street_number || ''
                                }
                                placeholder={address.getPropertyPlaceholder(
                                    'street_number'
                                )}
                            />
                            <input
                                data-street-name
                                data-field="street_name"
                                readOnly={
                                    !address.isPropertyEditable('street_name')
                                }
                                onChange={e =>
                                    onStreetNameChange(e.target.value)
                                }
                                className="m2g-customer-address-street-name-input m2g-input m2g-form-element--three-quarter-width m2g-form-element--left-join"
                                value={
                                    !address ? '' : address.street_name || ''
                                }
                                placeholder={address.getPropertyPlaceholder(
                                    'street_name'
                                )}
                            />
                        </div>
                    )}
                </div>

                <div
                    data-suburb-group
                    className="m2g-customer-address-line-3 m2g-customer-address-form-group  m2g-customer-address-form-group--suburb"
                >
                    <div
                        data-suburb-label
                        className="m2g-customer-address-form-group-label"
                    >
                        {address.getPropertyLabel('suburb')}
                    </div>
                    <div className="m2g-input-container m2g-customer-address-suburb m2g-customer-address-form-group-controls">
                        <input
                            data-suburb
                            data-field="suburb"
                            readOnly={!address.isPropertyEditable('suburb')}
                            className="m2g-customer-address-suburb-input m2g-input m2g-form-element--one-quarter-width m2g-form-element--right-join"
                            value={!address ? '' : address.suburb || ''}
                            placeholder={address.getPropertyPlaceholder(
                                'suburb'
                            )}
                            onChange={e =>
                                onSuburbChange(e.target.value)
                            }
                        />
                        <input
                            data-post-code
                            data-field="post_code"
                            readOnly={!address.isPropertyEditable('post_code')}
                            className="m2g-customer-address-post-code-input m2g-input m2g-form-element--left-join"
                            value={!address ? '' : address.post_code || ''}
                            placeholder={address.getPropertyPlaceholder(
                                'post_code'
                            )}
                            onChange={e =>
                                onPostcodeChange(e.target.value)
                            }
                        />
                    </div>
                </div>

                <div
                    data-comment-group
                    className="m2g-customer-address-form-group m2g-customer-address-form-group--comment"
                >
                    <div
                        data-comment-label
                        className="m2g-customer-address-form-group-label"
                    >
                        {address.getPropertyLabel('comment')}
                    </div>
                    <div className="m2g-customer-address-form-group-controls m2g-form-element-group">
                        <textarea
                            data-comment
                            data-field="comment"
                            className="m2g-customer-address-comment-textarea m2g-textarea m2g-form-element--full-width"
                            placeholder={address.getPropertyPlaceholder(
                                'comment'
                            )}
                            onChange={e => onCommentChange(e.target.value)}
                            readOnly={!address.isPropertyEditable('comment')}
                            value={!address ? '' : address.comment || ''}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

AddressForm.propTypes = {
    address: PropTypes.instanceOf(CustomerAddress).isRequired,
    is_showing: PropTypes.bool.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    onSpecificNumberChange: PropTypes.func.isRequired,
    onNameChange: PropTypes.func.isRequired,
    onStreetNumberChange: PropTypes.func.isRequired,
    onStreetNameChange: PropTypes.func.isRequired,
    onCommentChange: PropTypes.func.isRequired,
    onPostcodeChange: PropTypes.func.isRequired,
    onSuburbChange: PropTypes.func.isRequired
};

export default AddressForm;
